import { create } from "@bufbuild/protobuf";
import { ArrowLeftIcon, ImageBrokenIcon } from "@phosphor-icons/react";
import { createFileRoute, Outlet, useNavigate, useParams } from "@tanstack/react-router";

import Button, { ButtonSize, ButtonVariant } from "@gx/dls/buttons/Button";
import { GetProjectRequestSchema } from "@gx/ts-contracts/services/ontology/api/project_pb";

import ErrorLayout from "@/layouts/ErrorLayout";
import FullScreenLoader from "@/layouts/FullScreenLoader";
import ProjectSettingsLayout from "@/layouts/project/settings/ProjectSettingsLayout";

import { getProjectRefetchInterval } from "@/pages/projects/utils/projectRefetchInterval";

import { useGetProjectQuery } from "@/api/queries/projects";

export const Route = createFileRoute("/_secure/projects/$projectId/settings")({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectId } = useParams({ from: "/_secure/projects/$projectId/settings" });
  const navigate = useNavigate();

  const { data: project, isLoading: isLoadingProject } = useGetProjectQuery({
    input: create(GetProjectRequestSchema, { projectId }),
    options: {
      refetchInterval: (query) => getProjectRefetchInterval(query.state.data?.project),
    },
  });

  const handleGoToDashboard = () => {
    void navigate({ to: "/projects", search: {} });
  };

  if (isLoadingProject) {
    return <FullScreenLoader />;
  }

  if (!project?.project) {
    return (
      <ErrorLayout
        icon={ImageBrokenIcon}
        header="Project not found"
        message="The project you are looking for does not exist"
        actions={
          <Button
            label="Go to dashboard"
            icon={ArrowLeftIcon}
            variant={ButtonVariant.SECONDARY}
            size={ButtonSize.SMALL}
            onClick={handleGoToDashboard}
          />
        }
      />
    );
  }

  return (
    <ProjectSettingsLayout>
      <Outlet />
    </ProjectSettingsLayout>
  );
}
